import React from 'react';
export function makeReCaptchaElement(size, type) {
    class ReCAPTCHA extends React.Component {
        constructor(props) {
            super(props);
            this.handleErrored = this.handleErrored.bind(this);
            this.handleChange = this.handleChange.bind(this);
            this.handleRecaptchaRef = this.handleRecaptchaRef.bind(this);
        }
        getValue() {
            if (this.props.grecaptcha != null && typeof this._widgetId === 'number') {
                return this.props.grecaptcha.getResponse(this._widgetId);
            }
            return null;
        }
        getWidgetId() {
            if (this.props.grecaptcha != null && typeof this._widgetId === 'number') {
                return this._widgetId;
            }
            return null;
        }
        execute() {
            if (typeof this.props.grecaptcha?.execute === 'function' &&
                typeof this._widgetId === 'number') {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.props.grecaptcha.execute(this._widgetId);
            }
            else {
                this._executeRequested = true;
            }
        }
        async executeAsync() {
            return new Promise((resolve, reject) => {
                this.executionResolve = resolve;
                this.executionReject = reject;
                this.execute();
            });
        }
        reset() {
            if (this.props.grecaptcha != null && typeof this._widgetId === 'number') {
                this.props.grecaptcha.reset(this._widgetId);
            }
        }
        forceReset() {
            if (typeof this.props.grecaptcha?.reset === 'function') {
                this.props.grecaptcha.reset();
            }
        }
        handleExpired() {
            if (typeof this.props.onExpired === 'function') {
                this.props.onExpired();
            }
            else {
                this.handleChange(null);
            }
        }
        handleErrored() {
            if (typeof this.props.onErrored === 'function') {
                this.props.onErrored();
            }
            if (typeof this.executionReject === 'function') {
                this.executionReject();
                this.executionResolve = undefined;
                this.executionReject = undefined;
            }
        }
        handleChange(token) {
            if (typeof this.props.onChange === 'function') {
                this.props.onChange(token);
            }
            if (typeof this.executionResolve === 'function') {
                this.executionResolve(token);
                this.executionReject = undefined;
                this.executionResolve = undefined;
            }
        }
        explicitRender() {
            if (typeof this.props.grecaptcha?.render === 'function' &&
                this._widgetId === undefined) {
                const wrapper = document.createElement('div');
                this._widgetId = this.props.grecaptcha.render(wrapper, {
                    type,
                    size,
                    badge: this.props.badge,
                    isolated: this.props.isolated,
                    sitekey: this.props.sitekey,
                    tabindex: this.props.tabindex,
                    theme: this.props.theme,
                    callback: this.handleChange.bind(this),
                    'error-callback': this.handleErrored.bind(this),
                    'expired-callback': this.handleExpired.bind(this),
                });
                this.captcha.append(wrapper);
                if (typeof this.props.onMounted === 'function') {
                    this.props.onMounted();
                }
            }
            if (this._executeRequested &&
                this.props.grecaptcha != null &&
                typeof this._widgetId === 'number') {
                this._executeRequested = false;
                this.execute();
            }
        }
        componentDidMount() {
            this.explicitRender();
        }
        componentDidUpdate() {
            this.explicitRender();
        }
        handleRecaptchaRef(elem) {
            this.captcha = elem;
        }
        render() {
            // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
            const { 
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            sitekey, 
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            onChange, 
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            theme, 
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            tabindex, 
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            onExpired, 
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            onErrored, 
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            onMounted, 
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            grecaptcha, 
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            badge, 
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            isolated, ...childProps } = this.props;
            return (<div {...childProps} 
            // eslint-disable-next-line @typescript-eslint/unbound-method
            ref={this.handleRecaptchaRef}/>);
        }
    }
    return ReCAPTCHA;
}
